import * as React from "react";
import ModelContainer from "../../../components/model/ModelContainer";
import PageTitle from "../../../components/model/PageTitle";
import ModelTitle from "../../../components/model/ModelTitle";
import ModelInfo from "../../../components/model/ModelInfo";
import {GAEventModels} from "../../../utils/SendGAEvent";
import TabPanel from "../../../components/model/TabPanel";
import ModelDescription from "../../../components/model/ModelDescription";
import ParaphrasingToolModel from "./ParaphrasingToolModel";
import Disclaimer from "../../../components/model/Disclaimer";

const ParaphrasingTool = () => {
    return <ModelContainer>
        <PageTitle/>
        <div>
            <ModelTitle>Paraphrasing Tool</ModelTitle>
            <ModelInfo model={GAEventModels.PARAPHRASING_TOOL}/>
            <TabPanel
                modelName={GAEventModels.PARAPHRASING_TOOL}
                modelDescription={<ModelDescription>This tool automatically rewrites sentences, phrases or paragraphs. Maximum size of input is 1000 words.</ModelDescription>}
                content={<ParaphrasingToolModel/>}
            />
            <Disclaimer/>
        </div>
    </ModelContainer>;
};

export default ParaphrasingTool;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/ParaphrasingTool/index.tsx